import * as z from "zod";

export const hasLotTrackedProducts = {
  name: "hasLotTrackedProducts" as const,
  input: z.null(),
  output: z.boolean(),
};
